import style from "./Avatar.module.css";

const getInitials = (name: string | undefined) => {
  if (!name) {
    return "";
  }

  const words = name.split(" ").filter(Boolean).slice(0, 2);

  const first = Array.from(words[0])[0];
  const second = words.length > 1 && first.length === 1 ? Array.from(words[1])[0] : "";

  return `${first}${second}`;
};

interface AvatarProps {
  title: string;
}

export const Avatar = ({ title }: AvatarProps) => {
  return <div className={style.avatarWrapper}>{getInitials(title)}</div>;
};
